// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mwc-markets-treasury-ui-chart{margin:0 5px;border:0px solid #ccc;height:100%;min-height:200px}\n", "",{"version":3,"sources":["webpack://packages/treasury/src/components/chart-view.vue"],"names":[],"mappings":"AAAA,+BAA+B,YAAY,CAAC,qBAAqB,CAAC,WAAW,CAAC,gBAAgB","sourcesContent":[".mwc-markets-treasury-ui-chart{margin:0 5px;border:0px solid #ccc;height:100%;min-height:200px}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
